import { MenuItem } from "@mui/material";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import FormikActions from "../../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../../commons/formik/FormikAutocomplete";
import FormikSelect from "../../../../../commons/formik/FormikSelect";
import FormikTextField from "../../../../../commons/formik/FormikTextField";
import { StyledResolucion } from "../../../../../styled/Prevencion";
import { sustanciasForm1Validation } from "../formValidations";

const SustanciaFormPart1 = ({
  formModel,
  handleCancelSustancia,
  stepper,
  handleSubmit,
  sustanciasAgregadas,
  sustancia,
}) => {
  const sustancias = useSelector((state) => state.resolucion.sustancias.data);
  const unidadDeMedida = useSelector(
    (state) => state.resolucion.unidadDeMedida.data
  );

  return (
    <Formik
      initialValues={formModel}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      validationSchema={sustanciasForm1Validation(sustanciasAgregadas, sustancia)}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <StyledResolucion.GridContainer container spacing={3}>
            <StyledResolucion.RowContainer item xs={12} container>


              <StyledResolucion.RowContainer item xs={8}>
                <StyledResolucion.FormikInput>
                  <FormikTextField name="nombre" label="Nombre Comercial" fullWidth />
                </StyledResolucion.FormikInput>
              </StyledResolucion.RowContainer>
            </StyledResolucion.RowContainer>

            <StyledResolucion.RowContainer item xs={12} container>


              <StyledResolucion.RowContainer item xs={8}>
                <StyledResolucion.FormikInput>
                  <FormikAutocomplete
                    name="sustancia"
                    label="Código Sustancia - Descripción"
                    options={sustancias}
                  />
                </StyledResolucion.FormikInput>
              </StyledResolucion.RowContainer>
            </StyledResolucion.RowContainer>

            <StyledResolucion.RowContainer item xs={12} container>


              <StyledResolucion.RowContainer item xs={4}>
                <StyledResolucion.FormikInput>
                  <FormikTextField name="cantidad" label="Cantidad" fullWidth />
                </StyledResolucion.FormikInput>
              </StyledResolucion.RowContainer>

              <StyledResolucion.RowContainer item xs={4}>
                <StyledResolucion.FormikInput>
                  <FormikSelect
                    name="unidad"
                    label="Unidad de Medida"
                    fullWidth
                  >
                    {unidadDeMedida.map(({ id, nombre }) => {
                      return (
                        <MenuItem value={id} key={id}>
                          {nombre}
                        </MenuItem>
                      );
                    })}
                  </FormikSelect>
                </StyledResolucion.FormikInput>
              </StyledResolucion.RowContainer>
            </StyledResolucion.RowContainer>
          </StyledResolucion.GridContainer>
          {stepper ?? ""}
          <StyledResolucion.ButtonContainer style={{ padding: 10, justifyContent: "center" }}>
            <FormikActions
              handleCancel={handleCancelSustancia}
              submit="Paso siguiente"
            />
          </StyledResolucion.ButtonContainer>
        </Form>
      )}
    </Formik>
  );
};

export default SustanciaFormPart1;
